import { useEffect, useMemo, useState } from 'react';

import { useRegistryProducts } from '@/hooks/useRegistryCatalogue';
import { firmTotal } from './orderDraft';

/**
 * The documents step: the country's catalogue, what is ticked, and the
 * note to Armadillo. The catalogue is per country, so a country change
 * drops the ticks — a code from one country means nothing in another.
 */
export function useOrderDocuments(opened: boolean, country: string | null, active: boolean) {
  const [selected, setSelected] = useState<string[]>([]);
  const [notes, setNotes] = useState('');
  const catalogue = useRegistryProducts(country, opened && active);

  useEffect(() => {
    if (!opened) {
      setSelected([]);
      setNotes('');
    }
  }, [opened]);

  useEffect(() => {
    setSelected([]);
  }, [country]);

  const chosen = useMemo(
    () => catalogue.products.filter((product) => selected.includes(product.code)),
    [catalogue.products, selected]
  );

  return {
    catalogue,
    selected,
    setSelected,
    notes,
    setNotes,
    chosen,
    quoteCount: chosen.filter((product) => product.requiresQuote).length,
    total: useMemo(() => firmTotal(chosen), [chosen]),
  };
}

export type OrderDocuments = ReturnType<typeof useOrderDocuments>;
